import React from 'react'
import IndustrySector from '../industryComponents/IndustrySector'
import IndustryDesign from '../industryComponents/IndustryDesign'
import HomeTab from '../../home/HomeTab'
import HomeResource from '../../home/HomeResource'
import SustainabilityBanner from '../../sustainability/SustainabilityBanner'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import IndustryInvest from '../industryComponents/IndustryInvest'
import IndustryServe from '../industryComponents/IndustryServe'

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Industries",
  },
  {
    slug: "",
    page: "Other Industries",
  },
];

const bannerData = {
  img:"assets/images/other-industry-banner.webp",
  leftHead:"Other Industries",
  rightHead:"Simplifying Complex Operations Across Industries",
  desc:"Across diverse industries, managing critical business documents with accuracy, security, efficiency is essential. Dox and Box enables organizations to bring structure to their information, ensuring secure storage, streamlined workflows, instant access to data that powers daily operations."
}

const sectorData ={
  head:"Sector Overview",
  overview:"Organizations across various sectors handle large volumes of documents, records, operational data that require strict control, accessibility, compliance. Dox and Box provides secure, scalable, organized document management solutions that help businesses maintain control over their information, improve efficiency, ensure continuity in an increasingly data-driven environment."
}

const designData = {
  head:"Tailored Solutions for Diverse Business Needs",
  img:"/assets/images/other-industry-design.webp",
  desc:[
    "We specialize in delivering flexible and scalable document management systems designed to adapt to the unique requirements of different industries. Our solutions ensure that every document is organized, accessible, aligned with operational and compliance standards.",
    "With experience across multiple industries, we help organizations streamline processes, reduce manual effort, gain better control over critical information.",
  ],
  list:[
    "Organized management of corporate records and operational documents",
    "Secure user permissions for controlled information access",
    "Quick and dependable document search capabilities",
    "Standards-driven documentation and records systems",
    "Automated workflows to optimize day-to-day operations",
    "Growth-ready infrastructure designed for evolving business needs",
  ]
}


const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]

const investData = {
  head:"Why Businesses Across Industries Need Smart Document Management?",
  boxes:[
    {
      img:'/assets/images/other-industry-invest-1.webp',
      icon:"/assets/images/other-industry-invest-icon-1.webp",
      title:"Enhanced Data Security",
      desc:"Protect sensitive business information with robust security and controlled access.",
    },
    {
      img:'/assets/images/other-industry-invest-2.webp',
      icon:"/assets/images/other-industry-invest-icon-2.webp",
      title:"Faster Access to Information",
      desc:"Retrieve critical documents instantly to support quicker decision-making.",
    },
    {
      img:'/assets/images/other-industry-invest-3.webp',
      icon:"/assets/images/other-industry-invest-icon-3.webp",
      title:"Regulatory Compliance",
      desc:"Maintain accurate, audit-ready records aligned with industry standards.",
    },
    {
      img:'/assets/images/other-industry-invest-4.webp',
      icon:"/assets/images/other-industry-invest-icon-4.webp",
      title:"Operational Efficiency",
      desc:"Streamline document workflows to reduce delays and manual tasks.",
    },
    {
      img:'/assets/images/other-industry-invest-5.webp',
      icon:"/assets/images/other-industry-invest-icon-5.webp",
      title:"Cost Optimization",
      desc:"Lower storage and administrative costs through digitization and automation.",
    },
    {
      img:'/assets/images/other-industry-invest-6.webp',
      icon:"/assets/images/other-industry-invest-icon-6.webp",
      title:"Scalable Infrastructure",
      desc:"Adapt seamlessly to growing data volumes and evolving business needs.",
    },
  ]
}

const serveData = {
  head:"Other Industries We Serve",
  boxes:[
    {
      img:"/assets/images/educational-industry-serve-1.webp",
      title:"Healthcare Services",
      desc:"Healthcare services require precision, security, seamless access to critical records.",
      btnText:"Know More",
      slug:"/healthcare"
    },
    {
      img:"/assets/images/other-industry-serve-2.webp",
      title:"Media & Entertainment",
      desc:"Media & entertainment demands speed, organization, seamless access to high-volume content assets",
      btnText:"Know More",
      slug:"/media-entertainment-records-management"
    },
  ]
}

export default function OtherIndustry() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <SustainabilityBanner data={bannerData} />
      <IndustrySector data={sectorData} />
      <IndustryDesign data = {designData}/>
      <HomeTab tabData={tabData}/>
      <HomeResource/>
      <IndustryInvest data = {investData}/>
      <IndustryServe data={serveData}/>
    </>
  )
}
